__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "satknowledgeassistant";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.30.0", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(86722))))));
			register("@azure/msal-react", "1.4.9", () => (Promise.all([__webpack_require__.e(564), __webpack_require__.e(628)]).then(() => (() => (__webpack_require__(97564))))));
			register("@ey-xd/motif-react", "6.7.0+build2", () => (Promise.all([__webpack_require__.e(751), __webpack_require__.e(168), __webpack_require__.e(277), __webpack_require__.e(183)]).then(() => (() => (__webpack_require__(65183))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(621), __webpack_require__.e(699)]).then(() => (() => (__webpack_require__(92621))))));
			register("ag-charts-community", "8.2.1", () => (__webpack_require__.e(671).then(() => (() => (__webpack_require__(72671))))));
			register("ag-charts-react", "8.2.1", () => (Promise.all([__webpack_require__.e(94), __webpack_require__.e(979)]).then(() => (() => (__webpack_require__(28979))))));
			register("axios", "1.8.2", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(24344))))));
			register("d3-color", "3.1.0", () => (__webpack_require__.e(884).then(() => (() => (__webpack_require__(34884))))));
			register("datamaps", "0.5.9", () => (__webpack_require__.e(784).then(() => (() => (__webpack_require__(16784))))));
			register("dompurify", "3.3.1", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(87977))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(86178))))));
			register("pdfjs-dist", "4.3.136", () => (__webpack_require__.e(355).then(() => (() => (__webpack_require__(79355))))));
			register("react-d3-speedometer", "1.1.0", () => (Promise.all([__webpack_require__.e(652), __webpack_require__.e(677), __webpack_require__.e(173)]).then(() => (() => (__webpack_require__(87652))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(97950))), 1);
			register("react-idle-timer", "5.7.2", () => (__webpack_require__.e(724).then(() => (() => (__webpack_require__(67724))))));
			register("react-pdf", "9.0.0", () => (Promise.all([__webpack_require__.e(787), __webpack_require__.e(897), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(31787))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(508), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(97508))))));
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(53245))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(65043))), 1);
			register("recharts", "2.15.4", () => (Promise.all([__webpack_require__.e(751), __webpack_require__.e(838), __webpack_require__.e(677), __webpack_require__.e(554)]).then(() => (() => (__webpack_require__(25838))))));
			register("redux-saga", "1.4.2", () => (__webpack_require__.e(261).then(() => (() => (__webpack_require__(61261))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(805).then(() => (() => (__webpack_require__(50805))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(46453))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};